import {eventPropertiesClient} from 'common/report/queries/query-api/event-properties-client';

import {Store} from './store';

export interface EventProperties {
  [eventNames: string]: Array<Record<string, any>>;
}

export const eventPropertiesStore = new Store<EventProperties>({
  apiClient: eventPropertiesClient,
  defaultValue: {},
  name: `event-properties`,

  // in an app, different properties-menu instances can have different properties they need to show
  // based on the event names given to them. here we maintain a map of fetch params to property lists
  transform: {
    index: (response, {subscription}) => ({[Store.getKey(subscription.params, subscription.options)]: response}),
  },
});
